import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PermissionsGate from "../PermissionsGate";
import Billing from "./metas/Billing";
import BillingSubscription from "./BillingSubscription";
import Dashboard from "./Dashboard";
import CatProduits from "./CatProduits";

const Accounting = () => {
    const moduleName = "accounting";

    return (
        <Routes>
            <Route
                path="dashboard/*"
                element={
                    <PermissionsGate module={moduleName} submodule="dashboard">
                        <Dashboard />
                    </PermissionsGate>
                }
            />
            <Route
                path="cat-produits/*"
                element={
                    <PermissionsGate module={moduleName} submodule="cat-produits">
                        <CatProduits />
                    </PermissionsGate>
                }
            />
            <Route
                path="billing-metas/*"
                element={
                    <PermissionsGate module={moduleName} submodule="billing-metas">
                        <Billing />
                    </PermissionsGate>
                }
            />
            <Route
                path="billing-subscriptions/*"
                element={
                    <PermissionsGate module={moduleName} submodule="billing-subscriptions">
                        <BillingSubscription />
                    </PermissionsGate>
                }
            />
            <Route path="*" element={<Navigate to="dashboard" />} />
        </Routes>
    );
};

export default Accounting;
